import type { NavBarType } from "./types";
import { PLAN_BUILDER_INTERNET_URL } from "@/lib/clickthrough-destination";

export const defaultNavBar: NavBarType = {
  orderCta: {
    show: {
      mobile: false,
      tablet: true,
      desktop: true,
    },
    icon: "IconCart",
    showIcon: {
      mobile: false,
      tablet: true,
      desktop: true,
    },
    copy: "Order online",
    url: PLAN_BUILDER_INTERNET_URL,
    elementName: "ctaButtonNavOrderOnline",
    tagularProps: {
      location: "header",
      actionOutcome: "sentToLocalize",
    },
  },
  phoneCta: {
    show: {
      mobile: true,
      tablet: true,
      desktop: true,
    },
    icon: "IconPhone",
    showIcon: {
      mobile: true,
      tablet: true,
      desktop: true,
    },
    isIconOnlyOnMobile: false,
    copy: "Call to order:",
    copyTablet: "Call to order:",
    copyMobile: "Call to order",
    showLabel: {
      mobile: true,
      tablet: true,
      desktop: true,
    },
    showPhoneNumber: {
      mobile: false,
      tablet: true,
      desktop: true,
    },
    elementName: "ctaButtonNavPhoneNumber",
    tagularProps: {
      location: "header",
      actionOutcome: "phoneNumber",
    },
  },
  signIn: {
    copy: "Sign In",
    url: "https://login.xfinity.com/login",
    elementName: "textLinkNavSignIn",
    tagularProps: {
      location: "header",
    },
  },
  topBar: {
    show: {
      mobile: false,
      tablet: false,
      desktop: false,
    },
    eyebrow: "",
    copy: "",
    cta: {
      copy: "Order online",
      url: PLAN_BUILDER_INTERNET_URL,
    },
    prePhoneCopy: " or call ",
  },
};
